import BaseInputDatePicker from "./BaseInputDatePicker.vue";

export * from "./BaseInputDatePicker.vue";
export default BaseInputDatePicker;
